<template>
  <div>
    <m-2-m-order-dialog
      ref="orderDialog"
      :options="options"
      @changeOrder="emitValue"
    />
    <div class="wrapper">
      <el-select
        v-model="selectedValue"
        filterable
        :clearable="clearable"
        :multiple="multiple"
        :disabled="disabled"
        placeholder="Select an option"
        v-loading="loading"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        @click="openEditAddWindow"
        v-loading="loading"
        v-if="allowAddEdit"
        class="side-button"
        type="info"
        title="Create/edit in new tab"
      >
        <i class="el-icon" :class="value ? 'el-icon-edit' : 'el-icon-plus'" />
      </el-button>
      <el-button
        @click="fetchData"
        v-loading="loading"
        v-if="allowRefresh"
        class="side-button"
        title="Refresh"
      >
        <i class="el-icon el-icon-refresh"></i>
      </el-button>
      <el-button
        @click="openOrderDialog"
        v-loading="loading"
        v-if="sortable"
        class="side-button"
        title="Change order"
      >
        <i class="el-icon el-icon-sort"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import M2MOrderDialog from './M2MOrderDialog'
import { get } from 'lodash'

export default {
  props: {
    value: {
      type: [Array, Object, Number, String]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Boolean,
      default: false
    },
    allowRefresh: {
      type: Boolean,
      default: false
    },
    allowAddEdit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    paginated: {
      type: Boolean,
      default: true
    },
    labelField: {
      type: String,
      default: 'name'
    },
    valueField: {
      type: String,
      default: 'id'
    },
    service: {
      type: Object,
      required: true
    },
    serviceParams: {
      type: Object,
      default: () => ({ page_size: 'max' })
    }
  },
  components: {
    M2MOrderDialog
  },
  computed: {
    selectedValue: {
      set(newValue) {
        this.emitValue(newValue)
      },
      get() {
        return this.value
      }
    },
    editUrl() {
      return ''
    },
    addUrl() {
      return ''
    }
  },
  data() {
    return {
      options: [],
      loading: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const fetchPromise = this.getFetchPromise()
      if (fetchPromise == null) return
      fetchPromise
        .then(response => {
          this.options = this.getPreparedOptions(response.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPreparedOptions(responseData) {
      const prepareOptions = result => ({
        label: get(result, this.labelField),
        value: get(result, this.valueField)
      })
      const results = this.paginated ? responseData.results : responseData
      return results.map(prepareOptions)
    },
    emitValue(value) {
      this.$emit('input', value)
    },
    openOrderDialog() {
      this.$refs.orderDialog.openDialog(this.value)
    },
    getFetchPromise() {
      const params = this.serviceParams
      return this.service.fetch({}, { params })
    },
    openEditAddWindow() {
      if (this.allowAddEdit) {
        const routeDetails = this.value ? this.editUrl : this.addUrl
        const url = this.$router.resolve(routeDetails).href
        const windowOpened = window.open(url)
        const timer = setInterval(() => {
          if (windowOpened.closed) {
            clearInterval(timer)
            this.fetchData()
          }
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
}

.side-button {
  margin-left: 15px;
}
</style>
